import * as React from 'react';
import { routeInfo } from '../../../../routeInfo';
import { ConnectedProps, connect } from 'react-redux';
import handleViewport from 'react-in-viewport';
import * as actions from '../../../../redux/projects/actions.projects';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import * as moment from 'moment';
import history from '../../../../history';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import cancelEvent from '../../../../services/mini/cancelEvent';
import downloadScriptsHelper from '../../../../services/actionHelpers/downloadScriptsHelper';
import canChangeEnvironment from '../../../../services/mini/canChangeEnvironment';
import ConfirmPopup from '../../../components/ConfirmPopup/ConfirmPopup';
import * as _ from 'lodash';
import formats from '../../../../const/formats';
import InlineEditor from '../../../components/InlineEditor/InlineEditor';
import Menu from '../../../components/Menu/Menu';
import LineChartDiagram from '../../../components/Charts/LineChartDiagram';
import { ONE_MONTH, ONE_WEEK } from '../../../../const/periodRanges';
import projectHelper from '../../../../services/ProjectHelper';
import getDataForLineChartOnProjectTile from '../../../../services/mini/getDataForLineChartOnProjectTile';
import store from '../../../../store';
import Formatter from '../../../../services/Formatter';
import TabletAndBigger from '../../../components/TabletAndBigger/TabletAndBigger';
import device from '../../../../services/mini/device';
import { validateProjectName } from '../../../../services/validations/validateProjectName';
import { ScriptsDropZone } from '../../project/ScriptsDropZone/ScriptsDropZone';
import { TEXT_CHAT_ENABLED_KEY } from '../../embed/defaultProjectOptions';
import { Environment } from '../../../../const/environment';
import { IProject } from '../../../../models/IProject';
import { ReactChildrenGeneralType } from '../../../../models/ReactChildrenGeneralType';
import { IFormValidation } from '../../../../models/IFormValidation';
import { DEFAULT_BTN_LOGO_TRAIL, MIC_BTN_LOGO_TRAIL } from '../../../../const/defaultButtonLogos';
import { prepareBillingChartData } from '../../billing/BillingChart/prepareBillingChartData';
import { ConsumptionChart } from '../../../components/Charts/ConsumptionChart';
import { isUserBalancePositive } from '../../../../services/mini/isUserBalancePositive';

type ProjectTileProps = PropsFromRedux & {
    project: IProject
    inViewport: boolean
    movingTileIndex: number
    dragHandler: ReactChildrenGeneralType
    stats: any//todo: refactor it
    forwardedRef?: React.RefObject<HTMLDivElement>;
}

type ProjectTileState = {
    environment: Environment
    editProjectNameMode: boolean,
    projectTileMenuOpen: boolean,
    exportInProgress: boolean,
    isProjectDeletingInProcess: boolean,
    dndByClick: boolean
    renameInProcess: boolean
    requestStatTs: number
    consumptionsChartData: any
}

class ProjectTile extends React.Component<ProjectTileProps, ProjectTileState> {

    dndTrigger = React.createRef<HTMLDivElement>();

    constructor(props) {
        super(props);
        this.state = {
            environment: projectHelper.getEnvironment(props.project.projectId),
            requestStatTs: 0,
            consumptionsChartData: null,
            editProjectNameMode: false,
            projectTileMenuOpen: false,
            isProjectDeletingInProcess: false,
            dndByClick: false,
            renameInProcess: false,
            exportInProgress: false
        };

        this.dndTrigger = React.createRef();
    }

    shouldComponentUpdate(nextProps, nextState) {
        const curProps = this.props;
        const curState = this.state;

        if (curProps.project && nextProps.project) {
            if (curProps.project.name !== nextProps.project.name) {
                return true;
            }
            if (curProps.project.prodTagId !== nextProps.project.prodTagId) {
                return true;
            }
            if (curProps.project.stageTagId !== nextProps.project.stageTagId) {
                return true;
            }

            if (curProps.project.updateTs !== nextProps.project.updateTs) {
                return true;
            }

            if (curProps.movingTileIndex !== nextProps.movingTileIndex) {
                return true;
            }

            if (curProps.importConflictScripts !== nextProps.importConflictScripts) {
                return true;
            }
        }

        if (!curState.consumptionsChartData && nextState.consumptionsChartData) {
            return true;
        }

        if (!curProps.inViewport && nextProps.inViewport) {
            return true;
        }

        if (curState.requestStatTs !== nextState.requestStatTs) {
            return true;
        }

        if (curState.environment !== nextState.environment) {
            return true;
        }

        if (curState.isProjectDeletingInProcess !== nextState.isProjectDeletingInProcess) {
            return true;
        }

        if (curState.projectTileMenuOpen !== nextState.projectTileMenuOpen) {
            return true;
        }

        if (curState.dndByClick !== nextState.dndByClick) {
            return true;
        }

        if (curState.editProjectNameMode !== nextState.editProjectNameMode) {
            return true;
        }

        return false;
    }

    componentDidMount() {
        const { project } = this.props;

        this.getProjectStats(project.projectId);
    }

    componentDidUpdate(prevProps) {
        const { project } = this.props;

        if (!prevProps.inViewport && prevProps) {
            this.getProjectStats(project.projectId);
        }
    }

    getProjectStats = (projectId) => {
        const { environment } = this.state;
        const { inViewport } = this.props;

        if (projectId && inViewport) {
            this.props.getResourceUsagePerProject({
                projectId,
                environment,
            }).then((consumptions) => {
                this.setState({ consumptionsChartData: prepareBillingChartData(consumptions) });
            }).catch(() => {
                this.setState({ consumptionsChartData: prepareBillingChartData([]) });
            });
        }
    }

    validateProjectName = (projectName) => {
        let info = null;
        const { projects, project } = this.props;
        const res = {} as IFormValidation;

        const error = validateProjectName(projectName, projects, project.name);

        if (projectName.length > 50) {
            info = `Max project length: 50 characters`;
        }

        if (error) {
            res.error = error;
        }

        if (info) {
            res.info = info;
        }

        return res;
    }

    goToAnalytics = () => {
        const { project, user } = this.props;
        if (!isUserBalancePositive(user)) {
            history.push(routeInfo.billing.url());
            return;
        }
        history.push(routeInfo.analytics.url(project.name));
    }

    onEdit = () => {
        this.setState({ editProjectNameMode: true });
    }

    onDelete = (e) => {
        const { project } = this.props;

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Delete"
                        okBtnCb={() => {
                            if (!this.state.isProjectDeletingInProcess) {
                                this.setState({ isProjectDeletingInProcess: true }, () => {
                                    this.props.deleteProject(project.projectId);
                                    onClose();
                                });
                            }
                        }}
                        type="delete"
                        title="Delete Project"
                        message={<div>Are you sure you want to delete <b>{project.name}</b> project?</div>} />
                );
            }
        });

        cancelEvent(e);
    }

    onFileDialogCancel = () => {
        this.setState({ dndByClick: false });
    }

    onImport = () => {
        this.setState({ dndByClick: true }, () => {
            this.dndTrigger.current.click();
        });
    }

    onExport = (e) => {
        const { project } = this.props;
        const { exportInProgress, environment } = this.state;

        if (exportInProgress) return;

        this.setState({ exportInProgress: true }, async () => {
            try {
                await downloadScriptsHelper(project, environment);
                this.resetScriptsDownloading();
            } catch (e) {
                this.resetScriptsDownloading();
            }
        });
    }

    resetScriptsDownloading = () => {
        this.setState({ exportInProgress: false });
    }

    enterEditMode = () => {
        this.setState({ editProjectNameMode: true });
    }

    cancelEditMode = () => {
        this.setState({ editProjectNameMode: false });
    }

    goToProject = () => {
        const { project, user } = this.props;

        if (!isUserBalancePositive(user)) {
            history.push(routeInfo.billing.url());
            return;
        }

        history.push(routeInfo.project.url(project.name));
    }

    canChangePlan = (environment) => {
        const { tier } = store.getState().user;

        return canChangeEnvironment(tier, environment);
    }

    renameProject = (newName) => {
        const {
            project,
            renameProject
        } = this.props;

        this.setState({
            renameInProcess: true
        });

        renameProject({
            projectId: project.projectId,
            name: newName
        }).then(() => {
            this.cancelEditMode();
            this.setState({
                renameInProcess: false
            });
        });
    }

    onMenuOpened = () => {
        this.setState({ projectTileMenuOpen: true });
    }

    onMenuClosed = () => {
        this.setState({ projectTileMenuOpen: false });
    }

    render() {
        const { project, dragHandler, movingTileIndex, importConflictScripts, importFiles, features } = this.props;
        const {
            environment,
            editProjectNameMode,
            consumptionsChartData,
            projectTileMenuOpen,
            dndByClick,
            exportInProgress
        } = this.state;

        let logoUrl = null;

        try {
            const projectOptions = JSON.parse(project[`${environment}Options`]);
            const textChatEnabled = _.get(projectOptions['web'], TEXT_CHAT_ENABLED_KEY);
            logoUrl = textChatEnabled ? projectOptions['web']?.logoTextChat : projectOptions['web']?.logoIdle;
            if (logoUrl?.indexOf(MIC_BTN_LOGO_TRAIL) > -1 || logoUrl?.indexOf(DEFAULT_BTN_LOGO_TRAIL) > -1) {
                logoUrl = null;
            }
        } catch (error) {

        }


        const timeOptions = {
            allowYesterday: false,
            shortMins: true,
            shortMode: false,
            includeAgo: true
        };
        const updateTs = +project.updateTs;
        const updateTimeInfo = Formatter.getHumanTime(updateTs, Date.now(), timeOptions);
        let updateTime = Formatter.getHumanTimeFormatted(updateTs, Date.now(), timeOptions);
        if (updateTimeInfo.units === 'days') {
            updateTime += ' (' + moment(updateTs).format(formats.hh_mm_a) + ')';
            if (updateTimeInfo.count > 7) {
                updateTime = moment(updateTs).format(formats.MMM_DD_hh_mm_a);
                if (moment(updateTs).year() !== moment().year()) {
                    updateTime = moment(updateTs).format(formats.MMM_DD_YYYY_hh_mm_a);
                }
            }
        }

        return (
            <div className={`project-tile ${movingTileIndex !== null && 'moving-in-process'}`} ref={this.props.forwardedRef}>
                {!editProjectNameMode ? dragHandler : <div className="project-tile__fake-drag-handler"><i className="icon icon-drag-icon"></i></div>}
                <div className="project-tile__inner-wrapper">
                    <ScriptsDropZone
                        noClick={!dndByClick}
                        noKeyboard={true}
                        project={project}
                        environment={environment}
                        importConflictScripts={importConflictScripts}
                        importFiles={importFiles}
                        onDropAccepted={this.onFileDialogCancel}
                        onFileDialogCancel={this.onFileDialogCancel}>
                        <div className={`project-tile_header ${editProjectNameMode && 'edit-mode'}`} ref={this.dndTrigger}>
                            <div className="project-tile_header_content">
                                <div className="project-tile_header_first-row">

                                    <div className="project-tile_header_name">
                                        <div> {(logoUrl && !editProjectNameMode) && <img className="project-tile_header_logo" src={logoUrl} />}</div>
                                        {editProjectNameMode ?
                                            <InlineEditor
                                                value={project.name}
                                                editMode={true}
                                                key={project.name}
                                                autoFocus={true}
                                                validate={this.validateProjectName}
                                                maxLength={50}
                                                onEnterEditMode={this.enterEditMode}
                                                onLeaveEditMode={this.cancelEditMode}
                                                confirmAction={this.renameProject} /> :
                                            <div className={`project-tile_header_name_in-read-mode ${logoUrl ? 'with-logo' : ''}`}
                                                onClick={this.goToProject}
                                                title={project.name}>
                                                {project.name}
                                            </div>
                                        }
                                    </div>
                                    {!editProjectNameMode &&
                                        <div className={`project-tile_header_commands ${projectTileMenuOpen && 'opened'}`}>
                                            <Menu
                                                afterOpenCb={this.onMenuOpened}
                                                afterCloseCb={this.onMenuClosed}>
                                                <div onClick={this.onEdit}><i className="icon icon-alan-edit"></i>Rename</div>
                                                <div onClick={this.onExport} className={`${exportInProgress ? 'disabled' : ''}`}><i className="icon icon-alan-load-down"></i>Export</div>
                                                <div onClick={this.onImport} className={`${exportInProgress ? 'disabled' : ''}`}><i className="icon icon-alan-load-up"></i>Import</div>
                                                {(device.isDesktop() && features?.analytics?.enabled === true) && <div className="project-tile_menu_item" onClick={this.goToAnalytics}><i className="icon icon-analytics"></i>Analytics</div>}
                                                <div onClick={this.onDelete}><i className="icon icon-alan-trash"></i>Delete</div>
                                            </Menu>
                                        </div>
                                    }
                                </div>
                                <div className="project-tile_header_update-ts mobile">
                                    Updated {updateTime}
                                </div>

                            </div>
                        </div>
                        <div className={`project-tile_body stage`}>
                            <div className="project-tile_body_chart-area">
                                <div className="project-tile_body_chart-area_chart-holder">
                                    <ConsumptionChart data={consumptionsChartData} />
                                </div>
                            </div>
                            <div className="project-tile_bottom-row">
                                <div className={`project-tile_open-btn action-btn light-blue stage`}
                                    onClick={this.goToProject}>
                                    Open Project
                                </div>

                                <div className="project-tile_header_update-ts desktop">
                                    Updated {updateTime}
                                </div>
                            </div>

                        </div>
                    </ScriptsDropZone>
                </div>
            </div>);
    }
}

function mapStateToProps({ projectsInfo, config, user }) {
    return {
        projects: projectsInfo.projects,
        importConflictScripts: projectsInfo.currentProject.importConflictScripts,
        features: config.features,
        user: user
    };
}


function mapDispatchToProps(dispatch) {
    return {
        deleteProject: (projectId) => dispatch(actions.deleteProject(projectId)),
        renameProject: (param) => asyncDispatch(actions.renameProject, dispatch, param),
        importFiles: (param) => asyncDispatch(actions.importFiles, dispatch, param),
        getResourceUsagePerProject: (param) => asyncDispatch(actions.getResourceUsagePerProject, dispatch, param),
    };
}


const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default handleViewport(connector(ProjectTile), {});
